import { render, staticRenderFns } from "./AromaSecondaryNav.vue?vue&type=template&id=056aad9f&scoped=true"
import script from "./AromaSecondaryNav.vue?vue&type=script&lang=js"
export * from "./AromaSecondaryNav.vue?vue&type=script&lang=js"
import style0 from "./AromaSecondaryNav.vue?vue&type=style&index=0&id=056aad9f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056aad9f",
  null
  
)

export default component.exports